import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppRoutes } from './routes';
import { ToastHost } from './components/ui/Toast';
import './styles/index.css';

const client = new QueryClient({
  defaultOptions: {
    queries: {
      // A refused request is refused; retrying it just delays the message.
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 15_000,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <ToastHost>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </ToastHost>
    </QueryClientProvider>
  </StrictMode>,
);
